export default {
  items: [
    {
      title: 'holidaysPublic.nav.title',
      id: 'holidays-public',
      to: null,
      icon: 'calendar-days',
      sortOrder: 50,
      expanded: true,
      children: [
        {
          title: 'holidaysPublic.nav.supportRequests',
          to: { name: 'SupportRequestsPage' },
          icon: 'message-circle',
          sortOrder: 7,
        },
        {
          title: 'holidaysPublic.nav.myCompanies',
          to: { name: 'HolidaysPublicUserCompaniesPage' },
          icon: 'building-2',
          sortOrder: 5,
        },
        {
          title: 'holidaysPublic.nav.manage',
          to: { name: 'HolidaysPublicAdminPage' },
          icon: 'calendar-days',
          sortOrder: 10,
          permission: 'holidays public administer',
        },
        {
          title: 'holidaysPublic.nav.companyUsers',
          to: { name: 'HolidaysPublicCompanyUsersPage' },
          icon: 'users',
          sortOrder: 20,
          permission: 'holidays public administer',
        },
      ],
    },
  ],
}
